import React from 'react';
import { connect } from 'react-redux';
import app, {
    EVENT_DEVICE_TYPE_CHANGED,
} from 'general/js/app';
import eventBus from 'general/js/event-bus';
import {
    LiveArrowControl,
    controlTypes,
    modeTypes,
} from 'components/live-arrow-control';
import { SitecoreImageField } from 'components/sitecore-fields';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import userService from '../../../../general/js/user/user-service';
import CompetitionListCarousel from './competition-list-carousel';
import {
    handleMastercardRegistrationEnforce, getVerificationEndpoint, getUserAddressBooks, handlePersonalizedCompetitionList
} from '../helpers/toch-helpers';
import { TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME } from '../../../../general/js/user/constants';
import { addQueryParams, redirectTo } from '../../../../general/js/utils';
import { QueryConstants } from '../../../../general/js/utils/query-constants';

class CompetitionList extends React.Component {
    constructor(props) {
        super(props);
        this.gallery = null;

        this.state = {
            deviceType: app.deviceTypeByViewport,
            competitionsList: null,
            addressBooks: null
        };

        this.handleComponentPersonalization = this.handleComponentPersonalization.bind(this);
    }

    componentDidMount() {
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);

        this.handleComponentPersonalization();
    }

    handleComponentPersonalization() {
        const { competitions, hideCompletedCompetitions, verificationEndpoint } = this.props.data;

        const userAddressBooks = getUserAddressBooks();
        const hideCompetitions = hideCompletedCompetitions.toLowerCase() === 'true';

        if (hideCompetitions && !isEmpty(verificationEndpoint) && userAddressBooks === null) {
            this.handleComponentVisibility();
        }

        const newCompetitionList = handlePersonalizedCompetitionList(JSON.parse(userAddressBooks), competitions);

        if (hideCompetitions && newCompetitionList !== null) {
            this.setState({ competitionsList: newCompetitionList });
        }
    }

    handleComponentVisibility() {
        const endpoint = getVerificationEndpoint(this.props.data);

        axios.post(endpoint).then((response) => {
            if (response.data !== null && response.data !== undefined && response.data !== '') {
                userService.setDataInLocalStorage(TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME, JSON.stringify(response.data));
                this.setState({ addressBooks: response.data });
            }
        }).catch(() => {
            this.setState({ competitionsList: null });
        });
    }

    componentWillUnmount() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    onDeviceTypeChanged = (oldDeviceType, newDeviceType) => {
        this.setState({
            deviceType: newDeviceType
        });
    }

    onClickPrevBtn = () => {
        this.gallery.goTo('prev');
    }

    onClickNextBtn = () => {
        this.gallery.goTo('next');
    }

    getNode = (node) => {
        this.gallery = node;
    }

    shouldRenderCarousel(competitions) {
        if (competitions === null) return false;

        return competitions.length > 1;
    }

    onClick = (link) => {
        const {
            mastercardRegistrationPage
        } = this.props.data;

        if (handleMastercardRegistrationEnforce(this.props.data)) {
            redirectTo(addQueryParams(mastercardRegistrationPage.url, [
                {
                    key: QueryConstants.REDIRECT_URL,
                    value: link
                }
            ]));
            return;
        }

        userService.setDataInLocalStorage(QueryConstants.REDIRECT_URL, link);
        redirectTo(link);
    }


    render() {
        const {
            componentTitle,
            componentSubtitle,
            hasMastercardBranding,
            mastercardLogo,
            mastercardText,
            competitionTag,
            competitionListId,
            competitions,
            hideCompletedCompetitions
        } = this.props.data;
        const { competitionsList, addressBooks } = this.state;
        const personalizedCompetitionList = addressBooks !== null ? handlePersonalizedCompetitionList(addressBooks, competitions) : null;
        const newCompetitionList = personalizedCompetitionList !== null ? personalizedCompetitionList : competitionsList;
        const compList = !(hideCompletedCompetitions.toLowerCase() === 'true') ? competitions : newCompetitionList;

        const hasCarousel = this.shouldRenderCarousel(compList);
        const isMastercard = hasMastercardBranding.toLowerCase() === 'true';

        return (
            (compList !== null && compList !== undefined) &&
            <div className='competition-list__wrap' id={competitionListId}>
                <div className='competition-list__container container'>
                    <div className={`competition-list__content ${hasCarousel === false && isMastercard === true ? 'mastercard-branding-right' : 'mastercard-branding-left'}`}>
                        {
                            isMastercard &&
                            <div className='mastercard-branding-light'>
                                <SitecoreImageField img={mastercardLogo} className='mastercard-branding-light--logo' />
                                <div className='mastercard-branding-light--title'>{mastercardText}</div>
                            </div>
                        }
                        <h3 className='competition-list__heading'>
                            <span className='competition-list__title'>{componentTitle}</span>
                            <span className='competition-list__separator'>/</span>
                            <span className='competition-list__subtitle'>{componentSubtitle}</span>
                        </h3>
                        <div className='competition-list__buttons-wrapper-top'>
                            {
                                hasCarousel &&
                                <div className='competition-list__buttons'>
                                    <LiveArrowControl
                                        mode={modeTypes.carousel}
                                        type={controlTypes.prev}
                                        onClickPrevBtn={this.onClickPrevBtn}
                                    />
                                    <LiveArrowControl
                                        mode={modeTypes.carousel}
                                        type={controlTypes.next}
                                        onClickNextBtn={this.onClickNextBtn}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    <div className='competition-list__carousel'>
                        <div className='competition-list__carousel--container'>
                            <CompetitionListCarousel competitions={compList} competitionTag={competitionTag} getNode={this.getNode} hasCarousel={hasCarousel} onClick={this.onClick} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const CompetitionListContainer = connect(
)(CompetitionList);

export default CompetitionListContainer;
